import { render, staticRenderFns } from "./payroll_coach_row.vue?vue&type=template&id=53e45e63&"
import script from "./payroll_coach_row.vue?vue&type=script&lang=js&"
export * from "./payroll_coach_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports